import { topicApi } from '../../services/api/index';
import { standardOpeningHoursApi } from '../../services/api/standardOpeningHoursApi';
import { customerServiceContactNumberApi } from '../../services/api/customerServiceContactNumberApi';
import selectedTopicReducer from './selectedTopic';
import selectedContactPageReducer from './selectedContactPage';
import { customerServiceHolidaysApi } from '../../services/api/customerServiceHolidaysApi';
// import reset from './reset';

// Export  reducer  modules
const reducers = {
    [topicApi.reducerPath]: topicApi.reducer,
    [standardOpeningHoursApi.reducerPath]: standardOpeningHoursApi.reducer,
    [customerServiceContactNumberApi.reducerPath]: customerServiceContactNumberApi.reducer,
    [customerServiceHolidaysApi.reducerPath]: customerServiceHolidaysApi.reducer,
    selectedTopic: selectedTopicReducer,
    selectedContactPage: selectedContactPageReducer,
};
export default reducers;
